import { gridConfig } from "@tvg/fuse-responsive-grid";
import styled from "styled-components";

export const StyledSearchBarContainerContent = styled.div`
  position: relative;
  height: 48px;
  width: 100%;
`;

export const StyledSearchBarContent = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

export const StyledSearchBarContainer = styled.div`
  align-self: center;
  position: relative;
  width: 100%;
  margin-left: 0;
  z-index: 11;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    width: 572px; // to keep the same position with Search field in Head fragment from another repo
    margin-left: var(--spacing-space24);
  }
`;
